/**
 * 等级配置【主播】【财富】
 * @author  fulh
 * @update 2014-06-24 18:05:58
 *
 * 公用方法
 *
 * getStarLevel     : 获得主播等级,
 * getCoinLevel     : 获取数字等级,
 * getRichLevel     : 获取财富等级,
 * getStarLevelBean : 获取主播等级对应的维C值,
 * getRichLevelCoin : 获取财富等级对应的柠檬值,
 * getLevel         : 将柠檬或者维C转换为等级,
 * getRichIcon      : 获取财富等级图标信息,
 * getStarIcon      : 获取主播等级图标信息,
 * createStarIcon   : 获得主播图标的html标签,
 * createRichIcon   : 获得财富图标的html标签,
 * convertStarIcons : 转换页面上的主播图标，用于模板上的图标转换,
 * convertRichIcons : 转换页面上的用户图标，用于模板上的图标转换,
 * getShinningStar  : 获得闪星等级信息,
 * createVipIcon    : 创建vip图标信息
 * createIdenIcon   : 生成对应的身份标识
 * createProgress   : 生成进度条html
 *
 */
$.module('MM.level', function () {
  var config = {
    coin: {
      values: [
        0, 100, 1000, 3000, 5000, 10000, 15000, 20000, 30000, 40000, 50000,
        65000, 80000, 100000, 120000, 150000, 180000, 220000, 260000, 300000,
        350000, 400000, 450000, 500000, 560000, 630000, 700000, 770000, 840000,
        920000, 1000000, 1100000, 1200000, 1300000, 1400000, 1500000, 1600000,
        1700000, 1800000, 1900000, 2000000, 2100000, 2200000, 2300000, 2400000,
        2500000, 2620000, 2740000, 2880000, 3020000, 3180000, 3340000, 3500000,
        3680000, 3860000, 4060000, 4275000, 4500000, 4750000, 5000000, 5275000,
        5550000, 5825000, 6100000, 6400000, 6700000, 7000000, 7300000, 7650000,
        8000000, 8350000, 8750000, 9150000, 9550000, 10000000, 10500000,
        11000000, 11600000, 12200000, 12800000, 13500000, 14200000, 15000000,
        15800000, 16600000, 17400000, 18300000, 19200000, 20100000, 21000000,
        22000000, 23000000, 24000000, 25000000, 26000000, 27000000, 28000000,
        29000000, 30000000, 31200000, 32400000, 33600000, 34800000, 36000000,
        37200000, 38400000, 39600000, 40800000, 42200000, 43600000, 45000000,
        46400000, 47800000, 49200000, 50600000, 52000000, 53500000, 55000000,
        56750000, 58500000, 60500000, 62750000, 65000000, 67500000, 70000000,
        72500000, 75000000, 78000000, 81000000, 84000000, 87500000, 91000000,
        95000000, 99000000, 103500000, 108000000, 113000000, 118000000,
        123500000, 129000000, 135000000, 141000000, 147500000, 154000000,
        161000000, 168000000, 175500000, 183000000, 191000000, 199000000,
        207500000, 216000000, 225000000, 234500000, 244000000, 253500000,
        263500000, 273500000, 286000000, 298500000, 313500000, 328500000,
        343500000, 361000000, 378500000, 396000000, 416000000, 436000000,
        458000000, 480000000, 504000000, 528000000, 554000000, 580000000,
        608000000, 636000000, 666000000, 696000000, 726000000, 758000000,
        790000000, 822000000, 856000000, 890000000, 926000000, 962000000,
        1000000000, 1038000000, 1078000000, 1118000000, 1158000000, 1198000000,
        1238000000, 1283000000, 1328000000, 1378000000, 1428000000, 1483000000,
        1538000000, 1598000000, 1658000000, 1718000000, 1778000000, 1838000000,
        1898000000, 1958000000, 2018000000, 2078000000, 2138000000, 2198000000,
        2258000000, 2328000000, 2398000000, 2468000000, 2538000000, 2608000000,
        2678000000, 2748000000, 2818000000, 2888000000, 2958000000, 3038000000,
        3118000000, 3198000000, 3278000000, 3358000000, 3438000000, 3518000000,
        3598000000, 3678000000, 3758000000, 3848000000, 3938000000, 4028000000,
        4118000000, 4208000000, 4298000000, 4388000000, 4478000000, 4568000000,
        4658000000,
      ],
    },
    rich: {
      values: [
        0, 1000, 5000, 15000, 30000, 50000, 80000, 150000, 300000, 500000,
        700000, 1000000, 1500000, 2000000, 2500000, 3500000, 5000000, 7000000,
        10000000, 15000000, 21000000, 28000000, 36000000, 45000000, 55000000,
        70000000, 108000000, 168000000, 253500000, 458000000, 758000000,
        1158000000, 1658000000, 2258000000, 2958000000, 3758000000, 4658000000,
      ],
      names: [
        '庶民',
        '一富',
        '二富',
        '三富',
        '四富',
        '五富',
        '六富',
        '七️富',
        '八富',
        '九富',
        '十富',
        '举人',
        '贡士',
        '进士',
        '知府',
        '巡抚',
        '总督',
        '尚书',
        '太傅',
        '太师',
        '丞相',
        '藩王',
        '郡王',
        '亲王',
        '诸侯',
        '王爷',
        '皇帝',
        '大帝',
        '玉帝',
        '天尊',
        '创世之神',
        '纵横三界',
        '执掌乾坤',
        '乾坤圣王',
        '三界帝君',
        '六界神尊',
        '破碎虚空',
      ],
    },
    star: {
      values: [
        0, 2000, 12000, 34000, 70000, 140000, 240000, 360000, 500000, 640000,
        840000, 1100000, 1400000, 1800000, 2200000, 2800000, 3400000, 4000000,
        4600000, 5400000, 6200000, 7200000, 8400000, 9600000, 10800000,
        12000000, 14000000, 16000000, 18000000, 20000000, 24000000, 28000000,
        32000000, 36000000, 40000000, 46000000, 56000000, 66000000, 76000000,
        86000000, 96000000, 108000000, 120000000, 132000000, 144000000,
        156000000, 176000000, 196000000, 216000000, 236000000, 256000000,
        296000000, 336000000, 396000000, 456000000, 536000000, 616000000,
        696000000, 776000000, 896000000, 1016000000, 1136000000, 1336000000,
        1536000000, 1736000000, 1936000000, 2136000000, 2436000000, 2736000000,
        3036000000, 3336000000, 3636000000, 4036000000, 4436000000, 4836000000,
        5236000000,
      ],
      names: [
        '0星',
        '红星1',
        '红星2',
        '红星3',
        '红星4',
        '红星5',
        '五星1',
        '五星2',
        '五星3',
        '五星4',
        '五星5',
        '黄钻1',
        '黄钻2',
        '黄钻3',
        '黄钻4',
        '黄钻5',
        '白冠1',
        '白冠2',
        '白冠3',
        '白冠4',
        '白冠5',
        '白冠6',
        '白冠7',
        '白冠8',
        '白冠9',
        '白冠10',
        '蓝冠1',
        '蓝冠2',
        '蓝冠3',
        '蓝冠4',
        '蓝冠5',
        '蓝冠6',
        '蓝冠7',
        '蓝冠8',
        '蓝冠9',
        '蓝冠10',
        '橙冠1',
        '橙冠2',
        '橙冠3',
        '橙冠4',
        '橙冠5',
        '橙冠6',
        '橙冠7',
        '橙冠8',
        '橙冠9',
        '橙冠10',
        '紫冠1',
        '紫冠2',
        '紫冠3',
        '紫冠4',
        '紫冠5',
        '紫冠6',
        '紫冠7',
        '紫冠8',
        '紫冠9',
        '紫冠10',
        '黑冠1',
        '黑冠2',
        '黑冠3',
        '黑冠4',
        '黑冠5',
        '黑冠6',
        '黑冠7',
        '黑冠8',
        '黑冠9',
        '黑冠10',
        '金冠1',
        '金冠2',
        '金冠3',
        '金冠4',
        '金冠5',
        '金冠6',
        '金冠7',
        '金冠8',
        '金冠9',
        '金冠10',
      ],
    },
  };

  /**
   * 获取数字等级
   * @param  {Number} coin 柠檬
   * @return {Object}      等级信息
   */
  function _getCoinLevel(coin) {
    return _getRichLevel(coin);
    // coin = coin || 0;
    // var len = config.coin.values.length;
    // var level = _getLevelIndex('coin', coin, 0, len - 1)
    // var richLen = config.rich.values.length;
    // var richLevel = _getLevelIndex('rich', coin, 0, richLen - 1)
    // var nextValue = config.coin.values[level + 1] || 0
    // var value = config.coin.values[level]
    // var levelCoin = nextValue - value
    //
    // if (nextValue) {
    //     return {
    //         level: level, // 当前等级,
    //         richLevel: richLevel,
    //         nextLevel: level + 1,
    //         name: level, // 等级名称  //config.coin.names[level],
    //         coin: value, // 累计所需柠檬数
    //         levelCoin: levelCoin, // 等级所需柠檬数
    //         extraCoin: coin - value, // 当前等级多出的柠檬数
    //         upCoin: nextValue - coin,//还需多少升级的柠檬数量
    //         percent: ((coin - value) / levelCoin * 100).toFixed(2) + '%'
    //     }
    // } else {
    //     return {
    //         level: level, // 当前等级
    //         richLevel: richLevel,
    //         nextLevel: level,
    //         name: level, // 等级名称  //config.coin.names[level],
    //         coin: value, // 累计所需柠檬数
    //         levelCoin: value, // 等级所需柠檬数
    //         extraCoin: coin - value, // 当前等级多出的柠檬数
    //         upCoin: 0,//还需多少升级的柠檬数量
    //         percent: '100%'
    //     }
    // }
  }

  /**
   * 获取财富等级
   * @param  {Number} coin 柠檬
   * @return {Object}      等级信息
   */
  function _getRichLevel(coin) {
    coin = coin || 0;
    var len = config.rich.values.length;
    var level = _getLevelIndex('rich', coin, 0, len - 1);
    var nextValue = config.rich.values[level + 1] || 0;
    var value = config.rich.values[level];
    var levelCoin = nextValue - value;

    if (nextValue) {
      return {
        level: level, // 当前等级
        nextLevel: level + 1,
        name: level, // 等级名称  //config.coin.names[level],
        coin: value, // 累计所需柠檬数
        levelCoin: levelCoin, // 等级所需柠檬数
        extraCoin: coin - value, // 当前等级多出的柠檬数
        upCoin: nextValue - coin, //还需多少升级的柠檬数量
        percent: (((coin - value) / levelCoin) * 100).toFixed(2) + '%',
      };
    } else {
      return {
        level: level, // 当前等级
        nextLevel: level,
        name: level, // 等级名称  //config.coin.names[level],
        coin: value, // 累计所需柠檬数
        levelCoin: value, // 等级所需柠檬数
        extraCoin: coin - value, // 当前等级多出的柠檬数
        upCoin: 0, //还需多少升级的柠檬数量
        percent: '100%',
      };
    }
  }

  /**
   * 获得主播等级
   * @param  {Number} bean 柠檬数量
   * @return {Object}      等级信息
   */
  function _getStarLevel(bean) {
    bean = bean || 0;
    var len = config.star.values.length;
    var level = _getLevelIndex('star', bean, 0, len - 1);
    var nextValue = config.star.values[level + 1] || 0;
    var value = config.star.values[level];

    var levelBean = nextValue - value;

    if (nextValue) {
      return {
        level: level, // 当前等级
        nextLevel: level + 1,
        name: level, // 等级名称  //config.coin.names[level],
        bean: value, // 累计所需柠檬数
        levelBean: levelBean, // 等级所需柠檬数
        extraBean: bean - value, // 当前等级多出的柠檬数
        upBean: nextValue - bean, //还需多少升级的柠檬数量
        percent: (((bean - value) / levelBean) * 100).toFixed(2) + '%',
      };
    } else {
      return {
        level: level, // 当前等级
        nextLevel: level,
        name: level, // 等级名称  //config.coin.names[level],
        bean: value, // 累计所需柠檬数
        levelBean: value, // 等级所需柠檬数
        extraBean: bean - value, // 当前等级多出的柠檬数
        upBean: 0, //还需多少升级的柠檬数量
        percent: '100%',
      };
    }
  }

  /**
   * 根据值获取当前 等级
   * @param type
   * @param value
   * @param sIndex
   * @param eIndex
   * @returns {number|*}
   * @private
   */
  function _getLevelIndex(type, value, sIndex, eIndex) {
    var arr = config[type];
    var currentIndex = Math.floor((eIndex + sIndex) / 2);
    var nextIndex = currentIndex + 1;
    var currentValue = arr.values[currentIndex];
    var nextValue = arr.values[nextIndex];

    // MM.core.debug('getLevel', sIndex, eIndex, currentIndex, currentValue,value)

    if (nextIndex === eIndex) {
      if (value >= nextValue) {
        // MM.core.debug('getLevel result: eIndex', eIndex)
        return eIndex;
      }
      if (currentIndex === sIndex) {
        // MM.core.debug('getLevel result: sIndex', sIndex)
        return sIndex;
      }
    }

    if (currentIndex === sIndex) {
      // MM.core.debug('getLevel result: currentIndex', currentIndex)
      return currentIndex;
    }

    if (value < currentValue) {
      return _getLevelIndex(type, value, sIndex, currentIndex);
    } else {
      return _getLevelIndex(type, value, currentIndex, eIndex);
    }
  }

  /**
   * 获取主播等级对应的维C值
   * @param  {Number} level 主播等级
   * @return {Number}       对应的柠檬数量
   */
  function _getStarLevelBean(level) {
    var max = config.star.values.length - 1;
    level = level > max ? max : level;
    return config.star.values[level];
  }

  /**
   * 获取财富等级对应的柠檬值
   * @param  {Number} level 财富等级
   * @return {Number}       对应的柠檬数量
   */
  function _getRichLevelCoin(level) {
    var max = config.rich.values.length - 1;
    level = level > max ? max : level;

    return config.rich.values[level];
  }

  /**
   * 将柠檬或者维C转换为等级
   * @param  {Number}  coin   柠檬数
   * @param  {Boolean} isRich 是否是转换富豪等级
   * @return {Object}         返回对应的等级数据
   */
  function _getLevel(coin, isRich) {
    coin = coin || 0;

    var extraNum = 0,
      currNum = 0,
      level = 0,
      levelInfo = null;

    if (isRich) {
      levelInfo = _getRichLevel(coin);
      currNum = levelInfo.levelCoin;
      extraNum = levelInfo.extraCoin;
      level = levelInfo.level;
    } else {
      levelInfo = _getStarLevel(coin);
      currNum = levelInfo.levelBean;
      extraNum = levelInfo.extraBean;
      level = levelInfo.level;
    }

    return $.extend(
      {
        level: levelInfo.level,
        extraCoin: extraNum,
        currLvCoin: currNum,
        percentNum: currNum !== 0 ? extraNum / currNum : 1,
        percent:
          currNum !== 0
            ? ((extraNum / currNum) * 100).toFixed(1) + '%'
            : '100%',
      },
      isRich ? _getRichIcon(0, level) : _getStarIcon(0, level),
    );
  }

  /**
   * 获取财富等级图标信息
   * @param  {Number} coin  柠檬数量
   * @param  {Number} level 等级
   * @return {Object}       图标信息
   */
  function _getRichIcon(coin, level) {
    var currLV = level ? level : _getRichLevel(coin).level,
      max = config.rich.values.length;

    currLV = currLV > max ? max : currLV;

    return {
      icon: 'r_' + currLV,
      title: config.rich.names[currLV],
    };
  }

  /**
   * 获取数字等级图标信息
   * @param  {Number} coin  柠檬数量
   * @param  {Number} level 等级
   * @return {Object}       图标信息
   */
  function _getCoinIcon(coin, level) {
    var currLV = level,
      richLv = 0,
      max = config.coin.values.length,
      richMax = config.rich.values.length;

    if (level) {
      currLV = currLV > max ? max : currLV;
      richLv = _getRichLevel(config.coin.values[currLV]).level;
    } else {
      var res = _getCoinLevel(coin);
      currLV = res.level;
      currLV = currLV > max ? max : currLV;
      richLv = res.richLevel;
    }

    richLv = richLv > richMax ? richMax : richLv;

    return {
      icon: 'c_' + currLV + ' cr_' + richLv,
      title: currLV + '级',
    };
  }

  /**
   * 获取主播等级图标信息
   * @param  {Number} bean  维C数量
   * @param  {Number} level 等级
   * @return {Object}       等级信息
   */
  function _getStarIcon(bean, level) {
    var currLV = level ? level : _getStarLevel(bean).level,
      max = config.star.values.length;
    currLV = currLV > max ? max : currLV;

    return {
      level: currLV,
      icon: 's_' + currLV,
      title: config.star.names[currLV],
    };
  }

  /**
   * 获得主播图标的html标签
   * @param  {Number} bean  维C数量
   * @param  {Number} level 等级
   * @return {String}       等级标签
   */
  function _createStarIcon(bean, level) {
    var levelData = _getStarIcon(bean, level),
      tmpl = '<i class="starLV <%=icon%>" title="<%=title%>"></i>';

    return $.template(tmpl, levelData);
  }

  /**
   * 获得财富图标的html标签
   * @param  {Number} coin  柠檬数量
   * @param  {Number} level 等级
   * @param  {Number} weekspend 每周消费
   * @return {String}       等级标签
   */
  function _createRichIcon(coin, level, weekspend) {
    var levelData = _getRichIcon(coin, level),
      tmpl =
        '<i class="richLV <%=icon%>" title="<%=title%>"><%=shinningIcon%></i>';

    levelData.shinningIcon = _createShinningIcon(weekspend);

    return $.template(tmpl, levelData);
  }

  /**
   * 获得数字等级图标的html标签
   * @param  {Number} coin  柠檬数量
   * @param  {Number} level 等级
   * @return {String}       等级标签
   */
  function _createCoinIcon(coin, level, weekspend) {
    return _createRichIcon(coin, level, weekspend);
    // var levelData = _getCoinIcon(coin, level),
    //     tmpl      = '<i class="coinLV <%=icon%>" title="<%=title%>"><%=shinningIcon%></i>';
    //
    // levelData.shinningIcon = _createShinningIcon(weekspend);
    //
    // return $.template(tmpl, levelData);
  }

  /**
   * 获得闪星等级信息
   * @param  {Number} coin 柠檬数量
   * @return {Object}      闪星信息
   */
  function _getShinningStar(coin) {
    var res = {
      isShinning: false,
      icon: '',
      title: '',
    };

    if (!$.isNumeric(coin)) {
      return res;
    }

    coin = parseInt(coin, 10);

    if (coin >= 500000) {
      res.isShinning = true;
      res.type = 5;
      res.icon = 'star_5';
      res.title = '闪耀5星';
    } else if (coin >= 200000) {
      res.isShinning = true;
      res.type = 4;
      res.icon = 'star_4';
      res.title = '闪耀4星';
    } else if (coin >= 100000) {
      res.isShinning = true;
      res.type = 3;
      res.icon = 'star_3';
      res.title = '闪耀3星';
    } else if (coin >= 50000) {
      res.isShinning = true;
      res.type = 2;
      res.icon = 'star_2';
      res.title = '闪耀2星';
    } else if (coin >= 20000) {
      res.isShinning = true;
      res.type = 1;
      res.icon = 'star_1';
      res.title = '闪耀1星';
    }

    return res;
  }

  /**
   * 设置闪星图标
   * @param  {Number} spend 花费
   * @return {String}       icon的html
   */
  function _createShinningIcon(spend) {
    spend = spend || 0;

    if (spend === 0) {
      return '';
    }

    var data = _getShinningStar(spend),
      tmpl = '<b class=<%=icon%> title=<%=title%>></b>';

    return $.template(tmpl, data);
  }

  /**
   * 转换页面上的用户图标，用于模板上的图标转换
   * @param  {JQueyr} $container 对应区域的jq对象
   */
  function _convertRichIcons($container) {
    $('.convert-rich-level', $container || 'body').each(function (i, item) {
      var $item = $(item),
        coin = $item.data('coin'),
        weekspend = $item.data('weekspend');

      $item.replaceWith(_createCoinIcon(coin, null, weekspend));
    });
  }

  /**
   * 转换页面上的主播图标，用于模板上的图标转换
   * @param  {[type]} $container [description]
   * @return {[type]}            [description]
   */
  function _convertStarIcons($container) {
    $('.convert-star-level', $container || 'body').each(function (i, item) {
      var $item = $(item),
        bean = $item.data('bean');

      $item.replaceWith(_createStarIcon(bean));
    });
  }

  /**
   * 生成vip图标
   * @param  {String} vip vip类型
   * @return {String}     vip图标html
   */
  function _createVipIcon(vip) {
    if (vip === 0 || !vip) {
      return '';
    }
    return '<i class="iden-icon-v2 iden-vip" title="VIP"></i>';
  }

  /**
   * 生成对应的身份标识
   * @param  {Number} priv 身份标识
   * @param {Number} broker 经纪人等级（经纪人不为1级不展示icon
   * @return {String}      标识html
   */
  function _createIdenIcon(priv, broker, guild_priv) {
    if (priv === 3 || !priv) {
      return '';
    }

    var icon = 'other-star',
      title = '主播';

    switch (priv) {
      case 1:
        icon = 'operation';
        title = '运营';
        break;
      case 4: // 客服不显示
        return '';
      // icon = 'kefu';
      // title = '客服';
      // break;
      case 5:
        if (broker && broker === 1) {
          icon = 'proxy';
          title = '经纪人';
        } else if (guild_priv && guild_priv == 1) {
          icon = 'proxy-guild';
          title = '公会经纪人';
        } else {
          return '';
        }
        break;
      case 6:
        icon = 'gm';
        title = '巡警';
        break;
    }

    return (
      '<i class="iden-icon-v2 iden-' + icon + '" title="' + title + '"></i>'
    );
  }

  var _progressTmpl =
    '\
        <span class="progress-bar">\
            <i class="progress-bar-val" style="width:<%=percent%>;"></i>\
            <span class="progress-bar-text"><%=extraCoin%>/<%=_formatProgress(currLvCoin)%>(<%=percent%>)</span>\
        </span>\
    ';

  /**
   * 生成进度条html
   * @param  {Number}  coin   柠檬或者维C数量
   * @param  {Boolean} isRich 是否是财富等级
   * @return {String}         [description]
   */
  function _createProgress(coin, isRich) {
    var data = _getLevel(coin, isRich);

    return $.template(_progressTmpl, data);
  }

  /**
   * 格式化进度条后面的值
   */
  function _formatProgress(lvCoin) {
    if (lvCoin / 1000000 >= 1) {
      var str = parseInt(lvCoin / 10000) + '万';
      return str;
    }
    return lvCoin;
  }

  /**
   * 生成真爱团名牌
   * @param  {Number} level 用户真爱团等级
   * @return {String}     真爱团图标html
   */
  function _createGroupLevelIcon(level) {
    if (!level) {
      return '';
    }
    if (_.isObject(level)) {
      var user = level;
      level = _.get(user, 'love_group_level');
      var userId = _.get(user, '_id');
      var roomId = MM.live.room.getRoomId();
      var usersLevelKey = 'userGroupLevel' + roomId;
      var userLevelKey = usersLevelKey + '.' + userId;
      var userLevelMaps = ROOM_INFO[usersLevelKey];
      //优先取本地缓存的
      var userLevel = _.get(ROOM_INFO, userLevelKey);
      if (userLevel) {
        level = userLevel;
      } else {
        try {
          level = JSON.parse(level);
        } catch (e) {
          return '';
        }
        level = _.get(level, roomId);
        if (!level) {
          return '';
        }
        _.set(userLevelMaps, userId, level);
      }
    }
    var groupName = _.get(ROOM_INFO, 'group_info.group_name');
    var tmpl =
      '<i class="group-level<%=level%> group-level-info" title="真爱团粉丝等级">\
            <span class="group-fans-level"><%=level%></span>\
            <span class="group-name text-overflow"><%=groupName%></span>\
        </i>';
    var html = $.template(tmpl, {
      level: level,
      groupName: groupName,
    });
    return html;
  }

  /**
   * 真爱团&守护图标
   * @param info {object} {group_name,group_level,guard_type}
   * @private
   */
  function _createGroupGuardIcon(info) {
    if (!info || !info.group_name) {
      return null;
    }
    var loveType = Math.ceil(info.group_level / 10);
    var groupName = _.trim(info.group_name + '').slice(0, 3);

    var res = groupName.match(/[\u0000-\u00ff]/gi); // 匹配单字节字符
    var byteLen = res ? res.length : 0;

    var len = Math.ceil(byteLen / 2) + groupName.length - byteLen;

    return $.template(
      '<div class="tag-love <%= guard_type? "guard"+guard_type:"love"+loveType %>">\
        <span class="icon-love <%= guard_type? "guard"+guard_type:"love"+loveType %>"></span>\
        <span class="tag-love-level"><%= group_level %></span>\
        <span class="tag-love-name <%= guard_type?"icon-love guard"+guard_type+"-bg-"+group_name_len :"" %>" title="<%= group_name %>"><%= group_name %></span>\
        </div>',
      {
        loveType: loveType,
        group_name: groupName,
        group_name_len: len,
        group_level: info.group_level,
        guard_type: info.guard_type || 0,
      },
    );
  }

  function _getRichLevelByIndex(index) {
    return {
      level: index,
      name: _.get(config, 'rich.names.' + index),
      coin: _.get(config, 'rich.values.' + index),
    };
  }

  function _createPayIcon(level) {
    return '<span class="payLevel payLevel' + level + '"></span>';
  }

  return {
    getStarLevel: _getStarLevel,
    getRichLevel: _getRichLevel,
    getCoinLevel: _getCoinLevel,
    getRichLevelByIndex: _getRichLevelByIndex,
    getStarLevelBean: _getStarLevelBean,
    getRichLevelCoin: _getRichLevelCoin,
    getLevel: _getLevel,
    getRichIcon: _getRichIcon,
    getStarIcon: _getStarIcon,
    getCoinIcon: _getCoinIcon,
    createStarIcon: _createStarIcon,
    createRichIcon: _createRichIcon,
    createCoinIcon: _createCoinIcon,
    convertStarIcons: _convertStarIcons,
    convertRichIcons: _convertRichIcons,
    getShinningStar: _getShinningStar,
    createVipIcon: _createVipIcon,
    createIdenIcon: _createIdenIcon,
    createProgress: _createProgress,
    formatProgress: _formatProgress,
    createGroupLevelIcon: _createGroupLevelIcon,
    createGroupGuardIcon: _createGroupGuardIcon,
    createPayIcon: _createPayIcon,
  };
});
